module.exports = __webpack_public_path__ + "static/media/totalPnts_7500_10000.1ba150bd.png";